/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { YardDateField } from "../../../components/common/YardDateField";

import { useSearchableList } from "../../../dataProvider/useSearchableList";

import {
  Box,
  Card,
  Divider,
  Tab,
  Tabs,
  Toolbar,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";

import {
  BulkActionsToolbar,
  CreateButton,
  Datagrid,
  EditButton,
  FilterButton,
  FunctionField,
  ListContextProvider,
  RefreshButton,
  SelectInput,
  SimpleList,
  TextField,
  Title,
  TopToolbar,
  useListContext,
} from "react-admin";
import { FilterContext, FilterForm } from "ra-ui-materialui";
import { Form } from "react-final-form";

import {
  ChevronRightIcon,
  MobileIcon,
} from "../../../components/common/iconography";
import { CustomField } from "../../../components/common/CustomFields";
import { Empty } from "../../../components/common/Empty";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";
import { QuickFilter } from "../../../components/common/QuickFilter";
import { SearchField } from "../../../components/common/SearchField";
// import { BetaBadge } from "../../../components/common/FeatureBadges";
import ExportDropDown from "../../../components/common/ExportDropDown";
import { ListDatePicker } from "../../../components/common/ListDatePicker";
import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { accountNameRenderer } from "../../../components/common/AccountNameRenderer";
import { QuickMultiFilter } from "../../../components/common/QuickMultiFilter";
import ShipsTogetherBadge from "../../../components/common/shipWith/ShipsTogetherBadge";
import ShipsTogetherButton from "../../../components/common/shipWith/ShipsTogetherButton";
import useShipWithSelection from "../../../components/common/shipWith/useShipWithSelection";

import {
  AclType,
  CarrierType,
  CarrierTypes,
  OutboundStatus,
} from "../../../utils/constants";
import { isAuthorized, isSubscriptionDisabled } from "../../../utils/appUtils";
import {
  exceptionRenderer,
  normalizeValue,
  truncateText,
} from "../../../utils/utils";

import {
  BulkCreateInvoiceButton,
  CreateInvoiceButton,
} from "./CreateInvoiceButton";
import { AdvanceButton } from "./AdvanceButton";
import { outboundExportCsv, outboundExportPdf } from "./OutboundExports";
import { getChargeRules } from "../accounts/chargeRules/ChargeRuleUtils";

const useStyles = makeStyles((theme) => ({
  listRoot: {
    transition: theme.transitions.create(["all"], {
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  bulkActions: {
    // [classes.bulkActions] remove to restore original behavior
    marginTop: -theme.spacing(8),
    transition: theme.transitions.create("margin-top"),
  },
}));

const useToolbarStyles = makeStyles(
  (theme) => ({
    toolbar: {
      justifyContent: "space-between",
      alignItems: "flex-start",
      paddingRight: 0,
      [theme.breakpoints.up("xs")]: {
        paddingLeft: 0,
      },
      [theme.breakpoints.down("xs")]: {
        paddingLeft: theme.spacing(2),
      },
    },
    leftControlsXs: {
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        paddingRight: theme.spacing(2),

        // Make FilterForm inputs span full width on mobile
        "& [class*='RaFilterForm-form']": {
          width: "100%",
        },
        "& .filter-field": {
          width: "100%",
          flexBasis: "100%",
          flexGrow: 1,
        },
        // Remove the trailing spacer that prevents full-width controls
        "& .filter-field > div:last-child": {
          display: "none",
        },
      },
    },
  }),
  { name: "InboundListToolbar" },
);

const tabs = [
  {
    id: OutboundStatus.ADVICE_PENDING,
    name: "Advices",
    // name: (<span>Advices <BetaBadge /></span>),
    sortKey: "scheduledDateTime",
    sortOrder: "ASC",
    showSmall: false,
  },
  {
    id: OutboundStatus.PENDING,
    name: "Pending",
    sortKey: "scheduledDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.ARRIVED,
    name: "Arrived",
    sortKey: "arrivalDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.PLACED,
    // Drivers land here from the gate check-in on their phone.
    name: (
      <Box display="flex">
        <MobileIcon />
        PLACED
      </Box>
    ),
    // placementDateTime is not part of the by-dates GSIs; arrivalDateTime is,
    // and placing a load backfills it when unset, so it approximates placed
    // order for sorting.
    sortKey: "arrivalDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.LOADED,
    name: "Loaded",
    sortKey: "endDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: OutboundStatus.RELEASED,
    name: "Released",
    sortKey: "departureDateTime",
    sortOrder: "DESC",
    showSmall: true,
  },
];

const OutboundSearchField = (props) => {
  const { label, alwaysOn } = props;
  const { displayedFilters, filterValues, setFilters } = useListContext(props);

  const handleSearch = (value) => {
    if (value) {
      const normalizedValue = normalizeValue(value);
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(
        {
          ...nextFilterValues,
          or: [
            { assignedTo: { matchPhrasePrefix: `${value}` } },
            { carrierName: { matchPhrasePrefix: `${value}` } },
            { bolNumber: { matchPhrasePrefix: `${value}` } },
            { bolNumber: { wildcard: `*${value}*` } },
            // {
            //   normalizedPickupNumber: {
            //     matchPhrasePrefix: `${normalizedValue}`,
            //   },
            // },
            // { normalizedPoNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            // {
            //   normalizedConsigneePoNumber: {
            //     matchPhrasePrefix: `${normalizedValue}`,
            //   },
            // },
            // { normalizedRailCarNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            { normalizedPickupNumber: { wildcard: `*${normalizedValue}*` } },
            { normalizedPoNumber: { wildcard: `*${normalizedValue}*` } },
            {
              normalizedConsigneePoNumber: { wildcard: `*${normalizedValue}*` },
            },
            { normalizedRailCarNumber: { wildcard: `*${normalizedValue}*` } },
            { customFields: { matchPhrasePrefix: `${value}` } },
            { customFields: { wildcard: `*${value}*` } },
          ],
        },
        displayedFilters,
      );
    } else {
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(nextFilterValues, displayedFilters);
    }
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      handleSearch={handleSearch}
    />
  );
};

const getListFilters = (mdDown, tabValue) => {
  const filters = [
    <OutboundSearchField label="Search" tabValue={tabValue} alwaysOn />,
    <SelectInput
      source="carrierType.eq"
      label="Carrier Type"
      variant="outlined"
      resettable
      allowEmpty
      choices={CarrierTypes}
      helperText={false}
    />,
    <QuickFilter
      source="hasException"
      label="Has Exception"
      defaultValue={{ eq: true }}
    />,
  ];

  if (tabs[tabValue].id === OutboundStatus.RELEASED) {
    filters.push(
      <QuickMultiFilter
        label="Not Invoiced"
        source="and"
        defaultValue={{
          or: [{ invoiceId: { eq: " " } }, { invoiceId: { exists: false } }],
          skipInvoice: { ne: true },
        }}
      />,
      <ListDatePicker
        label="Date shipped"
        source="endDateTime"
        filterField="endDateTime"
      />,
    );
  }
  return filters;
};

/** Linking lives on the Advices and Pending tabs only (AD-8). */
export const isShipsTogetherTab = (tabId) =>
  tabId === OutboundStatus.ADVICE_PENDING || tabId === OutboundStatus.PENDING;

/** Row checkboxes: the two linkable tabs, plus Released for bulk invoicing. */
export const hasBulkActionsForTab = (tabId) =>
  isShipsTogetherTab(tabId) ||
  (tabId === OutboundStatus.RELEASED && isAuthorized(AclType.INVOICES));

export const BulkListActions = ({ tabValue, ...props }) => {
  if (tabValue === OutboundStatus.RELEASED)
    return <BulkCreateInvoiceButton {...props} />;
  if (isShipsTogetherTab(tabValue)) return <ShipsTogetherButton {...props} />;
  return null;
};

const OutboundListToolbar = (props) => {
  const {
    filters,
    actions,
    selectedAccountId,
    onAccountChange,
    onAccountsLoaded,
    xsDown,
    ...rest
  } = props;
  const classes = useToolbarStyles(props);

  return Array.isArray(filters) ? (
    <FilterContext.Provider value={filters}>
      <Toolbar className={classes.toolbar}>
        <Box
          display="flex"
          alignItems="flex-start"
          flexWrap="wrap"
          flexDirection={xsDown ? "column" : "row"}
          width={xsDown ? "100%" : undefined}
          className={xsDown ? classes.leftControlsXs : undefined}
        >
          <Form
            key={selectedAccountId || "account-all"}
            onSubmit={() => {}}
            initialValues={{ accountId: selectedAccountId || "" }}
            keepDirtyOnReinitialize
            render={() => (
              <Box
                mt={1}
                mr={xsDown ? 0 : 2}
                width={xsDown ? "100%" : undefined}
              >
                <AccountDropDown
                  source="accountId"
                  label="Account"
                  alwaysOn
                  helperText={false}
                  onAccountChange={onAccountChange}
                  onAccountsLoaded={onAccountsLoaded}
                />
              </Box>
            )}
          />
          <FilterForm />
        </Box>
        <span />
        {actions &&
          React.cloneElement(actions, {
            ...rest,
            filters, // IMPORTANT: FilterButton expects an array
            ...actions.props,
          })}
      </Toolbar>
    </FilterContext.Provider>
  ) : null;
};

const ListActions = (props) => {
  const { xsDown } = props;
  const { resource, total } = useListContext();

  return !xsDown ? (
    <TopToolbar>
      <FilterButton />
      <CreateButton disabled={isSubscriptionDisabled()} />
      <ExportDropDown
        total={total}
        resource={resource}
        exporter={outboundExportCsv}
        exporterPdf={outboundExportPdf}
      />
      <RefreshButton />
    </TopToolbar>
  ) : null;
};

const getSortOrder = (tabIndex) => {
  return tabs[tabIndex].sortOrder;
};

const getSortByWithScope = (tabValue, selectedAccountId) => {
  const tabIndex = tabs.findIndex((tab) => tab.id === tabValue);
  const key = selectedAccountId
    ? "outboundShipmentByAccountByStatusByDates"
    : "outboundShipmentByReloadYardByStatusByDates";
  return `{"key":"${key}", "search":"${tabs[tabIndex].sortKey}"}`;
};

const getDefaultFilterWithScope = (tabIndex, selectedAccountId) => {
  const statusFilter = {
    beginsWith: {
      status: tabs[tabIndex].id,
    },
  };

  if (selectedAccountId) {
    return {
      accountId: selectedAccountId,
      statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime:
        statusFilter,
    };
  }

  return {
    reloadYardId: window.appUser.reloadYardId,
    statusEndDateTimeArrivalDateTimeScheduledDateTimeCreateDateTime:
      statusFilter,
  };
};

const getDefaultSearchFilterWithScope = (tabIndex, selectedAccountId) => {
  if (selectedAccountId) {
    return {
      accountId: { eq: selectedAccountId },
      status: { eq: tabs[tabIndex].id },
    };
  }

  return {
    reloadYardId: { eq: window.appUser?.reloadYardId },
    status: { eq: tabs[tabIndex].id },
  };
};

const getFirstVisibleTab = (mdDown) =>
  mdDown ? tabs.findIndex((tab) => tab.showSmall) : 0;

const getSessionTab = (mdDown) => {
  const sessionTab = Number(sessionStorage.getItem(`OutboundTab`));
  // Only restore a session tab that is actually visible at the current breakpoint,
  // otherwise the hidden tab has no <Tab> to match and the grid shows the wrong status.
  if (
    sessionTab &&
    tabs[sessionTab] &&
    (!mdDown || tabs[sessionTab].showSmall)
  ) {
    return sessionTab;
  }
  return getFirstVisibleTab(mdDown); // Default to the first visible tab if the sessionTab is not valid
};

export const OutboundList = (props) => {
  const classes = useStyles();
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [tabIndex, setTabIndex] = useState(getSessionTab(mdDown));
  const reloadYardId = window.appUser?.reloadYardId;
  const accountStorageKey = `${props.resource}_${reloadYardId}_accountId`;
  const storedAccountId = localStorage.getItem(accountStorageKey);
  const [selectedAccountId, setSelectedAccountId] = useState(
    storedAccountId || null,
  );
  const [account, setAccount] = useState();

  const [defaultFilter, setDefaultFilter] = useState(() =>
    getDefaultFilterWithScope(tabIndex, selectedAccountId),
  );
  const [defaultSearchFilter, setDefaultSearchFilter] = useState(() =>
    getDefaultSearchFilterWithScope(tabIndex, selectedAccountId),
  );
  // Include key & search to display default sort order.
  const defaultSort = {
    field: getSortByWithScope(tabs[tabIndex].id, selectedAccountId),
    order: getSortOrder(tabIndex),
  };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = Number(
    localStorage.getItem(`${props.resource}_perPage`),
  );
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? sessionPerPage : 10,
  );
  const chargeRulesPreloadKeyRef = useRef(null);
  const [, setChargeRulesCacheVersion] = useState(0);

  const listContext = useSearchableList({
    ...props,
    defaultTitle: "Outbound",
    defaultFilter: defaultFilter,
    defaultSearchFilter: defaultSearchFilter,
    defaultPerPage: defaultPerPage,
    defaultSort: defaultSort,
    resource: "outboundShipments",
  });

  useEffect(() => {
    if (listContext?.perPage) {
      localStorage.setItem(`${props.resource}_perPage`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
  }, [listContext?.perPage]);

  useEffect(() => {
    if (listContext?.filter) {
      // Extract the key query from defaultSort
      const fieldObj = JSON.parse(defaultSort.field);
      const keyToCheck = fieldObj.key;

      // Check for the key's presence in filter
      const hasKey = keyToCheck in listContext.filter;
      const hasFilterValues = Object.keys(listContext.filterValues).length > 0;
      if (hasKey && hasFilterValues) listContext.setFilters({});
    }
  }, [listContext?.filter]);

  useEffect(() => {
    if (tabs[tabIndex].id !== OutboundStatus.RELEASED) {
      chargeRulesPreloadKeyRef.current = null;
      return;
    }

    const rows = (listContext?.ids || [])
      .map((id) => listContext?.data?.[id])
      .filter(Boolean);
    const accountIds = [
      ...new Set(
        rows
          .filter((record) => record.carrierType === CarrierType.RAIL)
          // Effective billing account: isInvoicable reads the cache under
          // billToAccountId, so preloading the shipment's own account leaves
          // brokered rows uncached and their ON_PULL storage gate blind.
          .map((record) => record.billToAccountId || record.accountId)
          .filter(Boolean),
      ),
    ].sort();

    const preloadKey = JSON.stringify(accountIds);
    if (chargeRulesPreloadKeyRef.current === preloadKey) return;

    chargeRulesPreloadKeyRef.current = preloadKey;
    if (!accountIds.length) return;

    let isMounted = true;
    Promise.all(accountIds.map((accountId) => getChargeRules(accountId)))
      .then(() => {
        if (!isMounted) return;
        setChargeRulesCacheVersion((version) => version + 1);
      })
      .catch(() => {
        chargeRulesPreloadKeyRef.current = null;
      });

    return () => {
      isMounted = false;
    };
  }, [tabIndex, listContext?.ids, listContext?.data]);

  const applyScopedDefaults = (nextTabIndex, nextAccountId) => {
    setDefaultFilter(getDefaultFilterWithScope(nextTabIndex, nextAccountId));
    setDefaultSearchFilter(
      getDefaultSearchFilterWithScope(nextTabIndex, nextAccountId),
    );
    listContext.setSort(
      getSortByWithScope(tabs[nextTabIndex].id, nextAccountId),
      getSortOrder(nextTabIndex),
    );
    listContext.setPage(1);
    const nextFilterValues = listContext.filterValues || {};
    listContext.setFilters(
      { ...nextFilterValues },
      listContext.displayedFilters,
    );
  };

  const handleTabChange = (value) => {
    setTabIndex(value);
    // A selection made on Pending must not carry into Advices.
    listContext.onUnselectItems?.();
    applyScopedDefaults(value, selectedAccountId);
  };

  // If the viewport narrows to md while a small-hidden tab (e.g. Advices) is
  // active, fall back to the first visible tab so the grid/query stay in sync.
  useEffect(() => {
    if (mdDown && !tabs[tabIndex].showSmall) {
      handleTabChange(getFirstVisibleTab(mdDown));
    }
  }, [mdDown]);

  // Restore the full account object (incl. outboundCustomFields) after a
  // page reload — AccountDropDown only emits onAccountChange on user input.
  // Must be referentially stable: it is a dependency of the accounts fetch
  // effect inside AccountDropDown.
  const handleAccountsLoaded = useCallback((accounts) => {
    const restoredId = localStorage.getItem(accountStorageKey);
    if (!restoredId) return;
    setAccount(
      (prev) => prev || accounts?.find((item) => item.id === restoredId),
    );
  }, []);

  const handleAccountChange = (selectedAccount) => {
    setAccount(selectedAccount || null);
    const nextAccountId = selectedAccount?.id || null;
    setSelectedAccountId(nextAccountId);
    if (nextAccountId) {
      localStorage.setItem(accountStorageKey, nextAccountId);
    } else {
      localStorage.removeItem(accountStorageKey);
    }
    applyScopedDefaults(tabIndex, nextAccountId);
  };

  return (
    <ListContextProvider value={listContext}>
      <Title title={<ForceTitle title="Outbound" />} />
      <OutboundListToolbar
        {...props}
        filters={getListFilters(mdDown, tabIndex)}
        actions={<ListActions xsDown={xsDown} />}
        xsDown={xsDown}
        selectedAccountId={selectedAccountId}
        onAccountChange={handleAccountChange}
        onAccountsLoaded={handleAccountsLoaded}
      />
      <Card
        className={classnames(
          classes.listRoot,
          { [classes.bulkActions]: listContext.selectedIds.length > 0 },
          // [classes.bulkActions] remove to restore original behavior
        )}
      >
        <BulkActionsToolbar>
          <BulkListActions tabValue={tabs[tabIndex].id} />
        </BulkActionsToolbar>
        <ShipmentTabs
          {...props}
          {...listContext}
          account={account}
          selectedAccountId={selectedAccountId}
          tabValue={tabIndex}
          setTabValue={handleTabChange}
          xsDown={xsDown}
          mdDown={mdDown}
        />
        <Pagination {...listContext} />
      </Card>
    </ListContextProvider>
  );
};

const ShipmentTabs = ({
  selectedAccountId,
  tabValue,
  setTabValue,
  setPage,
  ...props
}) => {
  const { mdDown } = props;

  const handleChange = (event, value) => {
    sessionStorage.setItem("OutboundTab", value);
    setTabValue(value);
  };

  return (
    <>
      <Tabs
        value={tabValue}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {tabs.map(
          (itm, idx) =>
            (!mdDown || itm.showSmall) && (
              <Tab
                key={itm.id}
                label={itm.name}
                id={`shipment-${idx}`}
                value={idx}
              />
            ),
        )}
      </Tabs>
      <Divider />
      {tabs.map(
        (itm) =>
          itm.id === tabs[tabValue].id && (
            <ShipmentGrid
              {...props}
              key={itm.id}
              selectedAccountId={selectedAccountId}
              tabValue={itm.id}
            />
          ),
      )}
    </>
  );
};

export const ShipmentGrid = ({
  ids,
  page,
  account,
  selectedAccountId,
  tabValue,
  ...props
}) => {
  const { xsDown, mdDown } = props;
  // A ships-together group cannot cross accounts, so once one load is picked
  // the other accounts' rows lose their checkbox.
  const isRowSelectable = useShipWithSelection(isShipsTogetherTab(tabValue));
  // Only show the account's custom field columns when an account filter is
  // applied; outbound shipments store values from outboundCustomFields
  const accountFields =
    account?.outboundCustomFields?.length > 0
      ? account.outboundCustomFields
      : [];
  const customGridFields = accountFields.map((field, index) => (
    <CustomField
      key={field.id}
      source={`customFields[${index}]`}
      field={field}
      label={field.name}
      sortable={false}
    />
  ));

  if (tabValue === OutboundStatus.PENDING && ids.length === 0 && page === 1)
    return <Empty {...props} message="Create a new outbound" />;
  else
    return xsDown ? (
      <SimpleList
        primaryText={(record) =>
          record.account?.displayName ?? record.accountName
        }
        secondaryText={(record) => `Pickup No: ${record.pickupNumber}`}
        tertiaryText={(record) =>
          record.assignedTo ? truncateText(record.assignedTo, 12) : null
        }
        leftIcon={(record) => (
          // Exception glyph (when any) above the ships-together badge, so
          // phones keep the highlight without a badge column.
          <Box display="flex" flexDirection="column" alignItems="center">
            {exceptionRenderer(record, null, false)}
            <ShipsTogetherBadge record={record} selfId={record.id} compact />
          </Box>
        )}
        rightIcon={() => (
          <ChevronRightIcon
            fontSize="large"
            color="secondary"
            style={{ marginLeft: 40, marginTop: 10 }}
          />
        )}
        linkType="edit"
      />
    ) : mdDown ? (
      <Datagrid
        rowClick="edit"
        hasBulkActions={hasBulkActionsForTab(tabValue)}
        isRowSelectable={isRowSelectable}
      >
        {tabValue === OutboundStatus.LOADED ||
        tabValue === OutboundStatus.RELEASED ||
        tabValue === OutboundStatus.ARRIVED ||
        tabValue === OutboundStatus.PLACED ? (
          <FunctionField
            source="hasException"
            label=" "
            render={(record) => exceptionRenderer(record, null, false)}
          />
        ) : null}
        <FunctionField
          source="shipWithIds"
          label=" "
          sortable={false}
          render={(record) => (
            <ShipsTogetherBadge
              record={record}
              selfId={record.id}
              size="small"
            />
          )}
        />
        <FunctionField
          source="accountName"
          label="Account"
          sortable
          render={accountNameRenderer}
        />
        <TextField source="poNumber" label="PO Number" sortable={true} />
        <TextField source="pickupNumber" label="Pickup No." sortable={true} />
        <TextField source="carrierName" label="Carrier Name" sortable={true} />
        {tabValue === OutboundStatus.ADVICE_PENDING ||
        tabValue === OutboundStatus.PENDING ? (
          <YardDateField
            source="scheduledDateTime"
            label="Scheduled Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === OutboundStatus.ARRIVED ? (
          <YardDateField
            source="arrivalDateTime"
            label="Arrival Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === OutboundStatus.PLACED ? (
          <YardDateField
            source="placementDateTime"
            fallbackSource="arrivalDateTime"
            label="Placed Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === OutboundStatus.LOADED ? (
          <YardDateField
            source="endDateTime"
            label="Loaded Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === OutboundStatus.RELEASED ? (
          <YardDateField
            source="departureDateTime"
            label="Shipped"
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {customGridFields}
      </Datagrid>
    ) : (
      <Datagrid
        rowClick="edit"
        hasBulkActions={hasBulkActionsForTab(tabValue)}
        isRowSelectable={isRowSelectable}
      >
        {tabValue === OutboundStatus.LOADED ||
        tabValue === OutboundStatus.RELEASED ||
        tabValue === OutboundStatus.ARRIVED ||
        tabValue === OutboundStatus.PLACED ? (
          <FunctionField
            source="hasException"
            label=" "
            render={(record) => exceptionRenderer(record, null, false)}
          />
        ) : null}
        <FunctionField
          source="shipWithIds"
          label=" "
          sortable={false}
          render={(record) => (
            <ShipsTogetherBadge
              record={record}
              selfId={record.id}
              size="small"
            />
          )}
        />
        <FunctionField
          source="accountName"
          label="Account"
          sortable
          render={accountNameRenderer}
        />
        <TextField source="poNumber" label="PO Number" sortable={true} />
        <TextField source="pickupNumber" label="Pickup No." sortable={true} />
        <TextField source="carrierName" label="Carrier Name" sortable={true} />
        {tabValue === OutboundStatus.ADVICE_PENDING ||
        tabValue === OutboundStatus.PENDING ? (
          <YardDateField
            source="scheduledDateTime"
            label="Scheduled Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === OutboundStatus.ARRIVED ? (
          <YardDateField
            source="arrivalDateTime"
            label="Arrival Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === OutboundStatus.PLACED ? (
          <YardDateField
            source="placementDateTime"
            fallbackSource="arrivalDateTime"
            label="Placed Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === OutboundStatus.LOADED ? (
          <YardDateField
            source="endDateTime"
            label="Loaded Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === OutboundStatus.RELEASED ? (
          <YardDateField
            source="departureDateTime"
            label="Shipped"
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === OutboundStatus.ARRIVED ||
        tabValue === OutboundStatus.PLACED ? (
          <TextField source="assignedTo" label="Assigned To" sortable />
        ) : null}
        {tabValue === OutboundStatus.RELEASED ? (
          <TextField source="bolNumber" label="BOL Number" sortable />
        ) : null}
        {customGridFields}
        {tabValue === OutboundStatus.RELEASED ? (
          <CreateInvoiceButton {...props} />
        ) : null}
        {tabValue === OutboundStatus.PENDING ? (
          <AdvanceButton
            record={props}
            newStatus={OutboundStatus.ARRIVED}
            buttonLabel="Set Arrived"
            {...props}
          />
        ) : null}
        {tabValue === OutboundStatus.PENDING ||
        tabValue === OutboundStatus.ARRIVED ? (
          <AdvanceButton
            record={props}
            newStatus={OutboundStatus.PLACED}
            buttonLabel="Set Placed"
            {...props}
          />
        ) : null}
        {tabValue === OutboundStatus.LOADED ? (
          <AdvanceButton
            record={props}
            newStatus={OutboundStatus.RELEASED}
            buttonLabel="Set Released"
            {...props}
          />
        ) : null}
        <EditButton />
      </Datagrid>
    );
};
